import { render, staticRenderFns } from "./ProjectSchemesAndDocuments.vue?vue&type=template&id=1ac135da&"
import script from "./ProjectSchemesAndDocuments.vue?vue&type=script&lang=js&"
export * from "./ProjectSchemesAndDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports